import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import { Loading } from '../../components/utility/Utility';
import '../../assets/css/components/program.css';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { responseHandler } from '../../components/utility/Utility';
import { GiveawaysHeader, GiveawaysInfo, GiveawaysRewards, GiveawaysReview } from '../../components/GiveawaysComponents';

export default function UpdateGiveaway() {
  const {handleSignOut, getJwtToken} = useContext(AuthContext);
  const [tutorial, setTutorial] = useState(0);
  const {id} = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [giveaway, setGiveaway] = useState(false);
  const [dynamicName, setDynamicName] = useState('');

  useEffect(() => {
    const getGiveawayData = async () => {
      try {
        const token = await getJwtToken();
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/giveaways',
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {id}
        });
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else if (res.data.status === 'executed') {
          navigate(`${location.pathname}/reporting`);
        } else {
          setGiveaway(res.data);
          setDynamicName(res.data.name);
        }
      } catch (err) {
        console.log(err);
      }
    }

    if (id === "tutorial") {
      setTutorial(1);
      if((!location.pathname.includes('/rewards') && !location.pathname.includes('/review'))) {
        setGiveaway({
          date_created: new Date(),
          filters: [],
          name: "Returning Customers",
          rewards: {
            breakdown: [],
            reward_type: "points"
          }
        });
      } else if ((location.pathname.includes('/rewards'))) {
        setGiveaway({
          date_created: new Date(),
          filters: [
            [{
              days: 90,
              days_operator: "$gt",
              filter_type: "spend",
              value: 50,
              value_operator: "$gt"
            }, 
            {
              filter_type: 'orders',
              days_operator: "any",
              value: "5",
              value_operator: "$gt"
            }],
            [{
              filter_type: "account",
              value: "1"
            }]
          ],
          name: "Returning Customers",
          rewards: {
            breakdown: [],
            reward_type: "points"
          }
        })
      } else if (location.pathname.includes('/review')) {
        setGiveaway({
          date_created: new Date(),
          filters: [
            [{
              days: 90,
              days_operator: "$gt",
              filter_type: "spend",
              value: 50,
              value_operator: "$gt"
            }, 
            {
              filter_type: 'orders',
              days_operator: "any",
              value: "5",
              value_operator: "$gt"
            }],
            [{
              filter_type: "account",
              value: "1"
            }]
          ],
          name: "Returning Customers",
          rewards: {
            breakdown: [
              {
                segment: 1000,
                coupon: {
                  name: "$5 off"
                }
              },
              {
                segment: 100,
                coupon: {
                  name: "$10 off"
                }
              },
              {
                segment: 10,
                coupon: {
                  name: "$25 off"
                }
              }
            ],
            reward_type: "coupon"
          }
        })
      }
      setDynamicName("Returning Customers");
    } else {
      getGiveawayData();
    }
  }, [location.pathname])

  return (
    <div className="main">
      <GiveawaysHeader dynamicName={dynamicName} />
      {(!location.pathname.includes('/rewards') && !location.pathname.includes('/review') && giveaway) &&
        <GiveawaysInfo 
          giveaway={giveaway} 
          setGiveaway={setGiveaway} 
          dynamicName={dynamicName} 
          setDynamicName={setDynamicName} 
          tutorial={tutorial}
          setTutorial={setTutorial}
        />
      }
      {(location.pathname.includes('/rewards') && giveaway) && 
        <GiveawaysRewards 
          giveaway={giveaway} 
          setGiveaway={setGiveaway} 
          tutorial={tutorial}
          setTutorial={setTutorial}
        />
      }
      {(location.pathname.includes('/review') && giveaway) &&
        <GiveawaysReview 
          giveaway={giveaway} 
          tutorial={tutorial}
          setTutorial={setTutorial}
        />
      }
    </div>
  )
}